// extracted by mini-css-extract-plugin
export default {"container":"TopNotificationCount_container__dE-Ww","count":"TopNotificationCount_count__Ukj4g"};